import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/query/keys.js';
import { fetchCarrierCoverage } from './api.js';

/**
 * Modes de livraison réellement configurés dans Shopify, pour la liste de
 * suggestions du champ « Mode de livraison » (`02` §9).
 *
 * Ils viennent de la matrice de couverture — c'est la même requête
 * `deliveryProfiles`, mise en cache sous la même clé, donc ouvrir le tiroir
 * après avoir consulté la matrice ne déclenche aucun appel supplémentaire.
 *
 * `enabled: store !== undefined` : sans boutique choisie, aucune suggestion,
 * et surtout aucune requête. Une erreur n'est pas remontée — le champ reste
 * une saisie libre, les suggestions sont un confort.
 */
export function useShippingMethods(store: string | undefined): string[] {
  const query = useQuery({
    queryKey: queryKeys.carriers.coverage(store ?? ''),
    queryFn: () => fetchCarrierCoverage(store ?? ''),
    enabled: store !== undefined && store !== '',
    staleTime: 5 * 60_000,
  });
  return query.data?.shippingMethods ?? [];
}
